import { fetchWithAuth } from "../api/client";
import {
  EmptyResponse,
  DashboardMetrics,
  ErrorResponse,
  Activity,
} from "../types";

export async function getDashboardMetrics(
  token: string
): Promise<DashboardMetrics> {
  const res = await fetchWithAuth("dashboard/summary", {
    method: "GET",
    token,
  });

  if (!res.ok) {
    throw new Error(`Error fetching dashboard summary: ${res.statusText}`);
  }

  return await res.json();
}

export async function getRecentActivities(token: string): Promise<Activity[]> {
  const res = await fetchWithAuth("AuditTrail/search", {
    method: "POST",
    token,
    body: JSON.stringify({ take: 50 }),
  });

  if (!res.ok) {
    throw new Error(`Error fetching dashboard summary: ${res.statusText}`);
  }

  return await res.json();
}
